import React from 'react'
import { Divider } from 'antd'
import styled from 'styled-components'

const Container = styled.div`
  .section-title {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .name {
    font-weight: 700;
    font-size: 24px;
    color: #29303e;
    font-family: 'Lato';
  }
  .description {
    font-size: 14px;
    color: #38435e;
    white-space: pre-wrap;
  }
  .extra-info.list {
    width: 50%;
    align-items: flex-end;
    ul {
      margin: 0;
      padding: 0;
      font-size: 12px;
      color: #52606c;
      font-family: 'Gilroy';
      list-style: none;
      display: flex;
      justify-content: space-between;
    }
  }
`

export default function SectionTitle(props) {
  const {
    question: { question, description, extra_info }
  } = props
  return (
    <Container>
      <div className="section-title">
        <div>
          <div className="name">{question}</div>
          <div className="description">{description}</div>
        </div>
        {extra_info && (
          <div className={`extra-info ${extra_info.type}`}>
            {extra_info.type === 'list' && (
              <ul className="list">
                {extra_info.content.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            )}
          </div>
        )}
      </div>
      <Divider />
    </Container>
  )
}
